import React from 'react';
import BlogPublishedSection from '../../../../sections/AdminDashboard/Content/Blog/BlogPublished';

const BlogPublished = () => {
  return <BlogPublishedSection />;
};

export default BlogPublished;

